"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var xss_filters_1 = require("xss-filters");
/**
 * @param locationSearchString: Url query part
 * @returns key-values map with query parameters. If there are not query parameters it will return {}
 */
exports.parseQuery = function (locationSearchString) {
    if (!locationSearchString) {
        return {};
    }
    var start = locationSearchString.indexOf('?');
    if (start !== -1) {
        locationSearchString = locationSearchString.substr(start + 1);
    }
    var query = {};
    var a = locationSearchString.split('&');
    for (var i = 0; i < a.length; ++i) {
        var b = a[i].split('=');
        if (b[1]) {
            var name_1 = decodeURIComponent(b[0]);
            if (name_1.indexOf('[]') !== -1) {
                // Url param could be an array: type[]=1&type[]=2
                // this would be converted to `type: [1, 2]`
                name_1 = name_1.substr(0, name_1.indexOf('[]'));
                if (!(name_1 in query)) {
                    // if we haven't added/init array for url param - do it:
                    query[name_1] = [];
                }
                // Add value to the array:
                query[name_1].push(decodeURIComponent(xss_filters_1.uriQueryInDoubleQuotedAttr(decodeURIComponent(b[1]))));
            }
            else {
                query[name_1] = decodeURIComponent(xss_filters_1.uriQueryInDoubleQuotedAttr(decodeURIComponent(b[1])));
            }
        }
    }
    return query;
};
//# sourceMappingURL=parseQuery.js.map